import React, { FunctionComponent, useState } from 'react';
import Image from 'next/image';
import { SocialMediaIconTypes } from '../../../constants/Enums';
import { ArticleModel } from '../../../services/content/article/models/ArticleModel';
import styles from '../../../styles/SocialMediaIcon.module.scss';

type Props = {
    type: SocialMediaIconTypes;
    className?: string;
    href?: string;
    article?: ArticleModel;
};

const SocialMediaIcons = {
    viber: { logo: '/viber.svg', alt: 'phone icon for sharing content' },
    email: { logo: '/email.svg', alt: 'email icon for sharing content' },
    whatsapp: { logo: '/whatsapp.svg', alt: 'whatsapp icon for sharing content' },
    facebook: { logo: '/facebook.svg', alt: 'facebook icon for sharing content' },
    messenger: { logo: '/messenger.svg', alt: 'messenger icon for sharing content' },
    clipboard: { logo: '/link.svg', alt: 'link icon for sharing content' },
    pinterest: { logo: '/pinterest.svg', alt: 'pinterest icon for sharing content' },
};

//INFO Creating a prop type, this will be used in future when we have to attach different functionality depending on the
// social icon click
export const SocialMediaIcon: FunctionComponent<Props> = ({ article, type, href, className }) => {
    const [displayCopiedTooltip, setDisplayCopiedTooltip] = useState(false);
    const anchorTarget = type === SocialMediaIconTypes.CLIPBOARD ? '_self' : '_blank';
    const toggleCopiedTooltip = (display: boolean) => {
        setDisplayCopiedTooltip(display);
        setTimeout(() => {
            setDisplayCopiedTooltip(false);
        }, 1000);
    };

    return (
        <a
            href={href ? href : generateHref(type, article)}
            className={`${className} social-media-logos d-flex flex-row justify-content-center position-relative`}
            target={anchorTarget}
            onClick={() => copyArticleLinkToClipboard(type, article, toggleCopiedTooltip)}>
            <Image
                src={SocialMediaIcons[type].logo}
                alt={SocialMediaIcons[type].alt}
                fill
                className={`normalize-nextjs-image`}
            />
            <div
                className={`px-2 ${displayCopiedTooltip ? 'position-absolute d-flex' : 'd-none'} ${
                    styles.copiedTooltip
                }`}>
                Копирано
            </div>
        </a>
    );
};

const copyArticleLinkToClipboard = (
    type: SocialMediaIconTypes,
    article?: ArticleModel,
    callback?: (toggle: boolean) => void,
) => {
    if (article && type === SocialMediaIconTypes.CLIPBOARD) {
        const articleLink = `${process.env.NEXT_PUBLIC_WEBSITE_URL}/article/${article?.id}`;

        navigator.clipboard.writeText(articleLink).then(
            function () {
                callback ? callback(true) : null;
            },
            function (err) {
                console.error('Could not copy text to clipboard: ', err);
            },
        );
    }
};

const generateHref = (type: SocialMediaIconTypes, article?: ArticleModel): string => {
    if (article) {
        const articleLink = `${process.env.NEXT_PUBLIC_WEBSITE_URL}/article/${article?.id}`;

        const hrefMap: any = {
            [SocialMediaIconTypes.CLIPBOARD]: 'javascript: void(0);',
            [SocialMediaIconTypes.VIBER]: `viber://forward?text=${article?.title} - прочети повече на ${articleLink}`,
            [SocialMediaIconTypes.EMAIL]: `mailto:?subject=${article?.title}&body=Прочети повече на ${articleLink}`,
            [SocialMediaIconTypes.WHATSAPP]: `https://api.whatsapp.com/send?text=${article?.title} - прочети повече на ${articleLink}`,
            [SocialMediaIconTypes.MESSENGER]: `fb-messenger://share/?link=${articleLink}&app_id=${process.env.NEXT_PUBLIC_SOCIAL_FB_APP_ID}`,
            [SocialMediaIconTypes.FACEBOOK]: `https://www.facebook.com/sharer/sharer.php?app_id=${process.env.NEXT_PUBLIC_SOCIAL_FB_APP_ID}&u=${process.env.NEXT_PUBLIC_WEBSITE_URL}/article/${article.id}`,
        };
        return hrefMap[type];
    }

    return '';
};
